export const allowedUsers = [
	"andrew.fitzell@analog.com",
	"anna.obrien@analog.com",
	"shane.clifford@analog.com",
	"jamie.clifford@analog.com",
	"conor.dempsey@analog.com",
	"matt.crivello@analog.com",
	"fearghal.osullivan@analog.com",
];
